import React from 'react';
import FeatureRichList from '../Common/RichList/FeatureRichList';

const TopUp = ({setStep, step, data, renderNote}) => {
	return (
		<FeatureRichList data={data || []} step={step} linkedPage setStep={setStep} subClass='subClass' renderNote={renderNote}/>
	);
};

export default TopUp;
